import React from 'react';
import PropTypes from 'prop-types';

const AudienceCount = ({ audienceCount, short, canSendSms }) => (
  <div className="epsilon u-type--light">
    <p>
      This campaign will engage{' '}
      <span className="u-type--semibold">{audienceCount}</span> clients.{' '}
      <span display-if={!short}>
        Only clients with
        {canSendSms ? ' a mobile app, email or phone number ' : ' a mobile app or email '}
        on file could be reached.
      </span>
    </p>
  </div>
);
AudienceCount.propTypes = {
  audienceCount: PropTypes.number.isRequired,
  short: PropTypes.bool,
  canSendSms: PropTypes.bool,
};
AudienceCount.defaultProps = {
  short: false,
  canSendSms: true,
};

export default AudienceCount;
